import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {userId} from '/redux/selector/currentUser.selector';
import {reportFilterCount} from '/redux/selector/myTeams.selector';
import {downlineCoachIds} from '/redux/selector/watchList.selector';

import WatchlistReportList from './WatchlistReportList';

export default connect(
  createStructuredSelector({
    viewTeamsReportFilterCount: reportFilterCount,
    userId,
    downlineCoachIds,
  }),
)(WatchlistReportList);
